import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../../../components/PageTemplate/PageTemplate';
import SavedProfiles from '../../../modals/components/layouts/business-dashboard/SavedProfiles/SavedProfiles';

export default function SavedProfilesPage() {
  const { t } = useTranslation();
  return (
    <Grid item lg={6} md={9} xs={12} sx={{ display: { xs: 'block' } }}>
      <PageTemplate
        title={t('left_side_bar.saved_profiles')}
        content={<SavedProfiles />}
      />
    </Grid>
  );
}
